module.exports = __webpack_public_path__ + "img/correcto.9ff55599.png";